@if (customFlow) {
  @if (!paymentMode?.isModeCrypto) {
    <div class='payments__custom-logos'>
      @for (item of customFlow?.payment; track $index) {
        <img
          defaultImage
          [alternative]="'https://cdn2.softswiss.net/logos/payments/color/' + item + '.svg'"
          [attr.data-src]="!paymentMode?.isModeCrypto ? '/assets/svg/payments/fiat/' + item + '.svg' : '/assets/svg/payments/coinspaid/color/' + item + '.svg'"
          [alt]="seo.metaTitle"
          >
      }
    </div>
  }
} @else {
  @if (!isLoadFromBanking()) {
    @if (!paymentMode?.isModeCrypto) {
      <div class="payments" >
        @for (image of paymentImages; track $index) {
          <img [class]="image.class" [src]="image.image" [alt]="seo.metaTitle">
        }
      </div>
    } @else {
      <div class="payments-crypto">
        @for (image of paymentImages; track $index) {
          <div class="payments-crypto__column">
            <img [class]="image.class" [src]="image.image" [alt]="seo.metaTitle">
            <h4 class="payments-crypto__text">{{image.text}}</h4>
          </div>
        }
      </div>
    }
  } @else {
    @if (bankingPayments$ | async; as payments) {
      @if (!paymentMode?.isModeCrypto) {
        <div class="payments">
          @for (item of payments; track $index) {
            <img class="filter-banking {{item?.slug}}"
              defaultImage
              [alternative]="item?.altImgSrc"
              [src]="item?.image" [alt]="seo.metaTitle">
          }
        </div>
      } @else {
        <div class="payments-crypto">
          @for (image of paymentImages; track $index) {
            <div class="payments-crypto__column">
              <img [class]="image.class" [src]="image.image" [alt]="seo.metaTitle">
              <h4 class="payments-crypto__text">{{image.text}}</h4>
            </div>
          }
        </div>
      }
    }
  }
}

